<x-shop-dialog
  i18n-heading="@@Order.Recreate.Heading"
  i18n-subheading="@@Order.Recreate.Subheading"
  heading="Order Updated"
  subheading="Your order has been updated successfully."
  (closeDialog)="closeDialog()"
>
  <ng-container *ngIf="data.itemsAdded?.length">
    <p class="mat-display-3" i18n="@@Order.Recreate.ItemsAdded.Message">
      The following items have been added to your order:
    </p>
    <div class="items mat-display-2">
      <div class="item" *ngFor="let orderItem of data.itemsAdded; trackBy: 'id' | trackBy">
        <x-media-thumbnail
          [url]="orderItem.media.url"
          [width]="36"
          [height]="36"
        ></x-media-thumbnail>

        <div class="product-name">{{ orderItem.productName }}</div>
      </div>
    </div>
  </ng-container>

  <x-shop-dialog-actions>
    <button xAction mat-stroked-button color="primary" (click)="closeDialog('shopping')">
      Continue Shopping
    </button>
    <button xAction mat-flat-button color="primary" (click)="closeDialog('checkout')">
      Checkout
    </button>
  </x-shop-dialog-actions>
</x-shop-dialog>
